import { useContext } from 'react';
import { PageTitle } from '../PageTitle';
import { RelatedItems } from '../RelatedItems';
import { InternalLayoutContext } from './InternalLayoutProvider';
import { useHasSidebar } from './useHasSidebar';
import { getContentAreaClassName } from './contentAreaClassName';

export const InternalLayout = ({ children }: { children: React.ReactNode }) => {
  const { relatedItems, larguraTotal } = useContext(InternalLayoutContext);
  const hasRelatedItems = !!relatedItems && relatedItems.length > 0;
  const hasSidebar = useHasSidebar(hasRelatedItems);

  return (
    <section id="main-content" className="mpf-internal-view">
      <div className="mpf-internal-view__grid">
        <article
          className={getContentAreaClassName({ hasSidebar, larguraTotal })}
        >
          <div className="mpf-internal-view__article">
            <PageTitle />
            {children}
          </div>
        </article>

        {hasRelatedItems && (
          <RelatedItems
            title="Links úteis"
            description="Acessos rápidos relacionados a esta página."
            relatedItems={relatedItems}
          />
        )}
      </div>
    </section>
  );
};

export { SubHomeLayout } from './SubHomeLayout';

export { useHasSidebar } from './useHasSidebar';

export { getContentAreaClassName } from './contentAreaClassName';

export {
  InternalLayoutProvider,
  InternalLayoutContext,
  type RelatedItem,
} from './InternalLayoutProvider';
